import type { JSX } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';

import type { JsxReplacements, TranslateHtmlOptions } from '../misc';
import { useI18n } from '../misc';

type Props = Readonly<{
	value: string;
	replacements?: JsxReplacements;
}> &
	TranslateHtmlOptions;

export function TranslateHtml({ value, replacements, ...options }: Props): JSX.Element {
	const { translateHtml } = useI18n();

	return <>{translateHtml(value, replacements, options)}</>;
}

type TypedProps = Readonly<{
	value: TranslationKey;
	replacements?: JsxReplacements;
}> &
	TranslateHtmlOptions;

export function TypedTranslateHtml({ value, replacements, ...options }: TypedProps): JSX.Element {
	const { typedTranslateHtml } = useI18n();

	return <>{typedTranslateHtml(value, replacements, options)}</>;
}
